/**
 * @deprecated Use isNullish from schemaDefinition/functions instead
 */
export const isNullish = (value: unknown): value is null | undefined => {
  return value === null || value === undefined;
};
